'use client';
import React, { useEffect, useRef } from 'react';
import BlazeSlider from 'blaze-slider';
import Image from 'next/image';
import Link from 'next/link';
function SliderDisplay({ is_guide, columns, textColor, isTextLinks, uid }) {
  const sliderRef = useRef(null);

  useEffect(() => {
    const slidesLength = columns.length;
    const slider = new BlazeSlider(sliderRef.current, {
      all: {
        slidesToShow: slidesLength,
        loop: false,
        transitionDuration: 400,
        slideGap: '0px'
      },
      '(max-width: 640px)': {
        slidesToShow: 1
      }
    });

    return () => slider.destroy();
  }, [columns.length]);

  return (
    <div
      ref={sliderRef}
      className={`highlight-slider-${uid} blaze-slider relative grid-cols-1 grid-rows-1 px-4 py-7 sm:px-5 sm:py-0 sm:pt-0 lg:px-0 ${is_guide ? 'gap-x-12 sm:grid-cols-6' : 'sm:grid-cols-3'}`}
    >
      <div className={`blaze-container grid min-h-[200px]`}>
        <div className="blaze-track-container pb-5">
          <ul className="blaze-track">
            {columns.map((item, index) => {
              const imageExists = !!item.image;
              const imageConnection = item.image;

              if (imageExists) {
                return (
                  <li
                    className={`flex flex-col justify-between px-3 sm:max-w-sm sm:px-4${isTextLinks ? 'sm:px-4 lg:px-20' : ''}`}
                    key={index}
                  >
                    {imageConnection.content_type != 'image/svg+xml' ? (
                      <div className="mx-auto min-w-full sm:min-w-[96px]">
                        <Image
                          src={imageConnection.url}
                          width="318"
                          height="486"
                          sizes="(min-width: 1024px) 96px, 318px"
                          style={{ objectFit: 'contain', aspectRatio: 48 / 73 }}
                          alt={imageConnection.title.replace(/\.[^/.]+$/, '')}
                          className={
                            'align-self mx-auto lg:max-h-[175px] lg:max-w-[96px]'
                          }
                        />
                      </div>
                    ) : (
                      <div className={`${is_guide ? '' : 'min-h-[51px]'}`}>
                        <Image
                          src={imageConnection.url}
                          width="70"
                          height="70"
                          sizes="70px"
                          alt={imageConnection.title.replace(/\.[^/.]+$/, '')}
                          className={`mx-auto ${is_guide ? 'max-h-[175px]' : ''}`}
                          loading="lazy"
                        />
                      </div>
                    )}
                    {item.title && (
                      <h3
                        className={`sh10 sm:sh9 ${is_guide ? 'mt-5 text-white' : isTextLinks ? 'text-default mt-5 mb-2' : 'text-default my-5'}`}
                      >
                        {item.title}
                      </h3>
                    )}
                    {item.description &&
                      (item.description !== '' ||
                        item.description !== null ||
                        item.description !== undefined) && (
                        <p
                          className={`body-r ${isTextLinks ? `mx-auto max-w-[276px]` : ``} ${is_guide ? `my-0 text-[${textColor}]` : `my-4 sm:mt-4 sm:mb-0 text-[${textColor}]'}`}`}
                        >
                          {item.description}
                        </p>
                      )}
                    {isTextLinks == true && (
                      <div className="txt-button mt-5 mb-10 sm:mb-5 lg:mb-0 lg:pb-5">
                        <Link
                          href={item.reference[0].url}
                          prefetch={false}
                          className="txt-btn-secondary"
                        >
                          {item?.link_text}
                        </Link>
                      </div>
                    )}
                  </li>
                );
              } else {
                return (
                  <li className="px-4 sm:max-w-sm" key={index}>
                    {item.title && (
                      <h3 className="sh10 sm:sh9 my-5">{item.title}</h3>
                    )}
                    {item.description &&
                      (item.description !== '' ||
                        item.description !== null ||
                        item.description !== undefined) && (
                        <p
                          className={`body-r my-4 leading-7 text-[${textColor}]`}
                        >
                          {item.description}
                        </p>
                      )}
                  </li>
                );
              }
            })}
          </ul>
        </div>
        <div
          className={`blaze-pagination indicators-dark absolute -bottom-3 mx-auto flex w-full`}
        ></div>
      </div>
      <button className={`blaze-prev hidden`}>
        <span className="sr-only">previous slide</span>
      </button>
      <button className={`blaze-next hidden`}>
        <span className="sr-only">next slide</span>
      </button>
    </div>
  );
}

export default SliderDisplay;
